jQuery(window).on('load', function () {
	Fancybox.bind('[data-fancybox]', {
		// ...
	});
});

if (jQuery("body").hasClass('directory') && jQuery("body").hasClass('members')) {
	// ACTIONS
	jQuery("#checkbox-all").on('change', function () {
		if (jQuery(this).prop('checked')) {
			jQuery("#rcpbp-membersearch-results .members-list td input[type='checkbox']").prop('checked', true);
		} else {
			jQuery("#rcpbp-membersearch-results .members-list td input[type='checkbox']").prop('checked', false);
		}
	});

	jQuery("#rcpbp-membersearch-results .add-to-existing-group").on('click', function () {
		var selectedTalent = [];

		jQuery("#rcpbp-membersearch-results .members-list td input[type='checkbox']:checked").each(function (index, element) {
			selectedTalent.push(jQuery(element).val());
		});

		if (selectedTalent.length > 0) {
			jQuery.redirect('/add-to-existing-group/', {
				ids: selectedTalent
			});
		} else {
			alert('Please select at least one talent to continue.');
		}
	});

	jQuery("#rcpbp-membersearch-results .create-group").on('click', function () {
		var selectedTalent = [];

		jQuery("#rcpbp-membersearch-results .members-list td input[type='checkbox']:checked").each(function (index, element) {
			selectedTalent.push(jQuery(element).val());
		});

		if (selectedTalent.length > 0) {
			jQuery.redirect('/create-group/', {
				ids: selectedTalent
			});
		} else {
			alert('Please select at least one talent to continue.');
		}
	});
}

if (jQuery("body").hasClass('group-admin') || jQuery("body").hasClass('group-home')) {
	// ACTIONS
	jQuery("#navigation-groups .toggle").on('click', function () {
		var $toggleState = jQuery(this).find('i');

		if ($toggleState.hasClass('icon-arrow-down')) {
			jQuery("#navigation-groups li:nth-of-type(1n+2)").fadeIn('fast');
			$toggleState.removeClass('icon-arrow-down').addClass('icon-arrow-up');
		} else if ($toggleState.hasClass('icon-arrow-up')) {
			jQuery("#navigation-groups li:nth-of-type(1n+2)").fadeOut('fast');
			$toggleState.removeClass('icon-arrow-up').addClass('icon-arrow-down');
		}
	});

	jQuery(window).on('resize', function () {
		if (window.innerWidth >= 1006 && jQuery("#navigation-groups").hasClass('desktop')) {
			jQuery("#navigation-groups li:nth-of-type(1n+2)").css('display', '');

			if (jQuery("#navigation-groups .toggle i").hasClass('icon-arrow-up')) {
				jQuery("#navigation-groups .toggle i").removeClass('icon-arrow-up').addClass('icon-arrow-down');
			}
		}
	});
}

if (jQuery("body").hasClass('groups') && jQuery("body").hasClass('directory')) {
	if (jQuery("body").hasClass('directory')) {
		// FUNCTIONS
		function autoClickAllGroups() {
			setTimeout(function () {
				jQuery(".item-list-tabs.unused a").trigger('click');
			}, 100);
		}

		// INITIALIZATION
		jQuery(window).on('load', function () {
			autoClickAllGroups();
		});
	}

	if (jQuery("body").hasClass('manage-members')) {
		// ACTIONS
		jQuery("#rcpbp-groups-actions .archive-group").on('click', function () {
			var element = jQuery(this);
			var status = element.data('status');

			jQuery.ajax({
				type: 'POST',
				url: adminAjax,

				data: {
					action: 'ajaxArchiveGroup',
					id: element.data('id'),
					status: status
				}
			}).done(function (msg) {
				location.reload()
			}).fail(function (jqXHR, textStatus) {
				alert('Cannot connect to the server. Please try again later.');
			});
		});
	}
}

if (jQuery("body").hasClass('mass-messaging')) {
	// FUNCTIONS
	function autoCheckGroup(group) {
		if (group != undefined) {
			jQuery("label:contains('" + group + "')").find('input[type="checkbox"]').prop('checked', true);
		}
	}

	function removeSendMessageArrow() {
		jQuery("#send").val('Send Message');
	}

	// INITIALIZATION
	jQuery(document).ready(function () {
		autoCheckGroup(getUrlParameter('group'));
		removeSendMessageArrow();
	});
}

if (jQuery("body").hasClass('my-messages')) {
	// ACTIONS
	jQuery("#message-threads input[type='checkbox']").on('change', function () {
		var checkbox = jQuery(this);

		if (checkbox.prop('checked')) {
			checkbox.parents('tr').addClass('selected');
		} else {
			checkbox.parents('tr').removeClass('selected');
		}
	});

	jQuery(".rcpbp-messages-list .navigation select").on('change', function () {
		window.location.href = jQuery(this).val();
	});
}

if (jQuery("body").hasClass('register')) {
	// FUNCTIONS
	function formTrackReferrerField() {
		jQuery("#signup_referrer").val(document.referrer);
	}

	function registrationFormReferrerTrack(email, username, referrer) {
		jQuery.ajax({
			type: 'POST',
			url: adminAjax,

			data: {
				action: 'ajaxRegisterAdditionalTracking',
				email: email,
				username: username,
				referrer: referrer
			}
		}).done(function () {
			jQuery("#signup_submit").click();
		}).fail(function (jqXHR, textStatus) {
			alert('Cannot connect to the server. Please try again later.');
		});
	}

	// INITIALIZATION
	jQuery(document).ready(function () {
		formTrackReferrerField();
	});

	// ACTIONS
	jQuery("#pseudo-submit").on('click', function () {
		var email = jQuery("#signup_email").val();
		var password = jQuery("#signup_password").val();
		var passwordConfirm = jQuery("#signup_password_confirm").val();
		var signupReferrer = jQuery("#signup_referrer").val();
		var username = jQuery("#signup_username").val();

		if (email == '' || username == '' || (password != passwordConfirm)) {
			jQuery("#signup_submit").on('click');
		} else {
			var section = getUrlParameter('section');

			if (section == undefined) {
				section = 'general';
			}

			Cookies.set('BuddyPress_Email', email);
			Cookies.set('BuddyPress_Username', username);

			jQuery.ajax({
				type: 'POST',
				url: adminAjax,

				data: {
					action: 'ajaxFirstRunRegister',
					section: section,
					username: username
				}
			}).done(function () {
				if (signupReferrer) {
					registrationFormReferrerTrack(email, username, signupReferrer);
				} else {
					jQuery("#signup_submit").on('click');
				}
			}).fail(function (jqXHR, textStatus) {
				alert('Cannot connect to the server. Please try again later.');
			});
		}
	});

	jQuery("#signup_username").on('blur', function () {
		jQuery("#field_1").val(jQuery(this).val());
	});

	jQuery("#template-notices .resend-activation").on('click', function () {
		var link = jQuery(this);
		var loader = jQuery(".spinner");
		var success = jQuery("#template-notices .resend-activation-success");

		link.css('display', 'none');
		success.css('display', 'none');
		loader.css('display', 'block');

		jQuery.ajax({
			type: 'POST',
			url: adminAjax,

			data: {
				action: 'ajaxResendActivation',
				emailAddress: Cookies.get('BuddyPress_Email'),
				username: Cookies.get('BuddyPress_Username')
			}
		}).done(function () {
			loader.css('display', 'none');
			link.css('display', 'block');
			success.css('display', 'block');
		}).fail(function (jqXHR, textStatus) {
			alert('Cannot connect to the server. Please try again later.');
		});
	});
}